import React from 'react';
import {
  Box,
  BoxProps,
  Theme,
  Typography,
  TypographyProps,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

const BADGE_OPACITY = 0.8;

const useStyles = makeStyles((theme: Theme) => ({
  badge: {
    backgroundColor: `rgba(0, 0, 0, ${BADGE_OPACITY})`,
    borderRadius: theme.spacing(0.25),
    display: 'inline-block',
    padding: theme.spacing(0, 0.5),
    zIndex: 1,
  },
  text: {
    color: '#FFFFFF',
    height: '100%',
    position: 'relative',
    zIndex: 1,
  },
}));

type Props = React.PropsWithChildren<{
  classes?: string;
  sx?: BoxProps['sx'];
  variant?: TypographyProps['variant'];
}>;

const CardOverlayBadge: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();
  const { children, classes: classesProp, sx, variant = 'caption' } = props;

  return (
    <Box className={classNames(classes.badge, classesProp)} sx={sx}>
      <Typography className={classes.text} variant={variant}>
        {children}
      </Typography>
    </Box>
  );
};

export default CardOverlayBadge;
